import React from 'react';
import { useBalanceVisibility } from '../contexts/BalanceVisibilityContext';

const BalanceVisibilityToggle = () => {
  const { hidden, toggle } = useBalanceVisibility();

  return (
    <button
      type="button"
      onClick={toggle}
      aria-label={hidden ? 'Mostrar saldos' : 'Ocultar saldos'}
      aria-pressed={hidden}
      className="flex h-10 w-10 items-center justify-center rounded-full border border-slate-200 bg-white text-lg text-slate-600 shadow-sm transition-colors hover:bg-slate-100"
    >
      <i className={hidden ? 'bi-eye-slash' : 'bi-eye'}></i>
    </button>
  );
};

export default BalanceVisibilityToggle;
